export class WbFlightLogPivotModel {
  pivotKey: string;
  totalFlightCount: number;
  sumGrossPayload: number;
  maxGrossPayload: number;
  minGrossPayload: number;
  stdDevGrossPayload: number;
  avgGrossPayload: number;
  quartile1GrossPayload: number;
  medianGrossPayload: number;
  quartile3GrossPayload: number;
  // flightsAboveAverageGrossPayload: number;
  // flightsBelowAverageGrossPayload: number;
  sumZfw: number;
  maxZfw: number;
  minZfw: number;
  stdDevZfw: number;
  avgZfw: number;
  quartile1Zfw: number;
  medianZfw: number;
  quartile3Zfw: number;
  sumTakeoff: number;
  maxTakeoff: number;
  minTakeoff: number;
  stdDevTakeoff: number;
  avgTakeoff: number;
  quartile1Takeoff: number;
  medianTakeoff: number;
  quartile3Takeoff: number;
  sumFuelCalc: number;
  maxFuelCalc: number;
  minFuelCalc: number;
  stdDevFuelCalc: number;
  avgFuelCalc: number;
  quartile1FuelCalc: number;
  medianFuelCalc: number;
  quartile3FuelCalc: number;
  payloadMathMismatchCount: number;
  payloadMathMismatchRate: number;
  sumGrossPayloadDifference: number;
  maxGrossPayloadDifference: number;
  minGrossPayloadDifference: number;
  stdDevGrossPayloadDifference: number;
  avgGrossPayloadDifference: number;
  gladUtilization: number;
  loadedCubeCodeUtilization: number;
}
